import { render } from "./ConfirmSlipAdd.vue?vue&type=template&id=b90dfefc&scoped=true"
import script from "./ConfirmSlipAdd.vue?vue&type=script&lang=js"
export * from "./ConfirmSlipAdd.vue?vue&type=script&lang=js"

import "./ConfirmSlipAdd.vue?vue&type=style&index=0&id=b90dfefc&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b90dfefc"]])

export default __exports__